import "gantt-task-react/dist/index.css";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { Cell, Legend, Pie, PieChart } from "recharts";

import Button from "@lhd/components/Button";
import { ROUTES } from "@lhd/constants";
import { Select, Spin, Tabs } from "antd";
import { isEmpty } from "lodash";
import SchedulerBox from "./ProjectGanttChart/SchedulerBox";
import Tasks from "./ProjectGanttChart/Tasks";
import useProjectManagement, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

export const SelectOptionsProject = [
  {
    label: "全てプロジェクト",
    value: "ALL_PROJECT",
  },
  {
    label: "自分タスク",
    value: "TASK_ASSIGN_ME",
  },
];
const DEFAULT_TAB = "table";

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={"middle"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const ProjectManagementLayout: FC<Props> = ({
  currentDate,
  tasks,
  events,
  pieChartData,
  isShowCalendar,
  projects,
  page,
  total,
  isFetchProject,
  isFetchTask,
  projectId,
  setProjectId,
  setPage,
  setIsShowCalendar,
  handleDate,
  filter,
  setFilter,
  clientOptions,
  isFetchingClient,
  onChangeSelectProject,
  valueSelectProject,
  preStepsCount,
  setSearchParams,
  searchParams,
}) => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState<string>(DEFAULT_TAB);
  const tabParams = searchParams.get("tab");

  const onChange = (key: string) => {
    setSearchParams({
      tab: key,
    });
  };

  useEffect(() => {
    if (!tabParams) {
      setSearchParams({
        tab: DEFAULT_TAB,
      });
    } else {
      setActiveKey(tabParams);
    }
  }, [tabParams, setSearchParams]);

  return (
    <Styles>
      <div className="group-btn background-white p-2">
        <Button
          label="プロジェクト一覧"
          onClick={() => navigate(ROUTES.PROJECT_LIST)}
        />
      </div>

      <div className="project-container">
        <h3 className="project-header">参加プロジェクト</h3>

        <Spin spinning={isFetchProject}>
          <div className="project-info">
            {isEmpty(projects) ? (
              <div
                style={{
                  height: 400,
                  textAlign: "center",
                  marginTop: "68px",
                  color: "#777777",
                  opacity: "0.8",
                  fontWeight: 700,
                  fontSize: "16px",
                }}
              >
                <p>データがありません。</p>
              </div>
            ) : (
              <div>
                <div className="project-list">
                  {projects?.map((item, index) => (
                    <div
                      className={`item ${
                        projectId === item.id ? "active" : ""
                      }`}
                      key={index}
                      onClick={() => {
                        setProjectId(item.id);
                        navigate(`${item.id}/tasks`, {
                          state: {
                            projectTitle: item.name,
                            note: item?.note,
                          },
                        });
                      }}
                    >
                      <p>{item.name}</p>
                      <AiOutlineDoubleRight
                        size={16}
                        color={
                          projectId === item.id ? "#fff" : "rgba(0, 0, 0, 0.25)"
                        }
                      />
                    </div>
                  ))}
                </div>
                {!isEmpty(projects) && total > 10 && total !== projects.length && (
                  <p
                    className="see-more"
                    onClick={() => {
                      if (total === projects.length) return;
                      setPage(page + 1);
                    }}
                  >
                    もっと見る
                  </p>
                )}
              </div>
            )}

            <PieChart width={400} height={400}>
              <Pie
                data={pieChartData}
                cx={160}
                cy={240}
                innerRadius={60}
                outerRadius={150}
                dataKey="value"
                labelLine={false}
                label={renderCustomizedLabel}
                width={500}
                height={500}
              >
                {pieChartData.map((item: any, index: number) => (
                  <Cell key={`cell-${index}`} fill={item.colors} />
                ))}
              </Pie>
              <Legend />
            </PieChart>
          </div>
        </Spin>
      </div>

      <div className="p-2 background-white">
        <Spin
          spinning={isFetchTask}
          style={{
            width: "100%",
          }}
        >
          <div className="gantt-chart">
            <Tabs
              defaultActiveKey={DEFAULT_TAB}
              activeKey={activeKey}
              onChange={onChange}
              className="tab-custom"
            >
              <Tabs.TabPane tab={"ガントチャート"} key="table">
                <>
                  <div className="date-control">
                    <div className="wrap-button">
                      <Select
                        className="select"
                        options={SelectOptionsProject}
                        defaultValue={
                          valueSelectProject || SelectOptionsProject[0]?.value
                        }
                        onChange={onChangeSelectProject}
                      />
                    </div>
                    <div className="wrapper">
                      <BiChevronLeft
                        size={24}
                        onClick={() => handleDate(true)}
                      />
                      <p>{moment(currentDate).format("YYYY年MM月")}</p>
                      <BiChevronRight
                        size={24}
                        onClick={() => handleDate(false)}
                      />
                    </div>
                  </div>
                  {isEmpty(tasks) ? (
                    <div
                      style={{
                        width: "100%",
                        height: 400,
                        textAlign: "center",
                        paddingTop: "40px",
                        color: "#777777",
                        border: "1px solid #bcbcbc",
                        opacity: "0.8",
                        fontWeight: 700,
                        fontSize: "16px",
                      }}
                    >
                      <p>データがありません。</p>
                    </div>
                  ) : (
                    <Tasks tasks={tasks} preStepsCount={preStepsCount} />
                  )}
                </>
              </Tabs.TabPane>
              <Tabs.TabPane tab="被評価者設定" key="calendar">
                <SchedulerBox tasks={tasks} events={events} />
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Spin>
      </div>
    </Styles>
  );
};

const ProjectManagement: FC<ReceivedProps> = (props) => (
  <ProjectManagementLayout {...useProjectManagement(props)} />
);

export default ProjectManagement;
